import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import {
  IFormShareOfBusiness,
  IFormShareOfBusinessItem,
} from 'legacy/lut/classes/models/partner360/IFormShareOfBusiness'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import ShareOfBusinessHelper from 'legacy/lut/components/widgets/public/partner360/shareOfBusiness/helpers/ShareOfBusinessHelper'
import {
  topVendorBrandA3,
  topVendorBrandA4,
} from 'legacy/lut/features/partner360/shareOfBusiness/helpers'
import { IShareOfBusiness } from 'legacy/lut/features/partner360/shareOfBusiness/models'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export type TUpdatePartner360SOB = {
  partnerId: string
  fYear: number
  programType: ProgramTypes
  devicesInfo: IShareOfBusiness
}

export const updatePartner360SOB = async ({
  partnerId,
  fYear,
  programType,
  devicesInfo,
}: TUpdatePartner360SOB) => {
  const setDelete = (data: IFormShareOfBusinessItem[], isColapsed: boolean) => {
    return data.map((el) => {
      if (isColapsed) {
        el.Delete = !el.SubCategory.endsWith('-overall')
      } else {
        el.Delete = el.SubCategory.endsWith('-overall')
      }

      return el
    })
  }

  const category = 'jbp-sob-print-hw-contractual'
  const subCategoryA3 = 'jbp-sob-print-hw-contractual-a3'
  const subCategoryA4 = 'jbp-sob-print-hw-contractual-a4'
  const emptyFormat: IFormActualsTargetsSettings = {
    EntryId: 0,
    ProgramType: '',
    JBPGeoUnit: '',

    BusinessUnit: '',
    BusinessUnitOrder: 0,
    Category: '',
    CategoryTranslation: '',
    CategoryOrder: 0,
    SubCategory: '',
    SubCategoryOrder: 0,
    L3Category: '',
    L3CategoryOrder: 0,

    SummaryProgram: 0,
    HideIfEmpty: 0,
    ShowNotApplicable: 0,
    ShowUnits: 0,
    ShowShipments: 0,
    PLs: '',
    PopupComment: '',
    Colors: '',
    Settings: '',
    IsContractualsAvailable: 0,
    IsSoBAvailable: 0,
    IsUnitsAvailable: 0,
    IsHideFinancial: 0,
    IsMainHierarchy: 0,
    MandatoryType: 0,
    MandatoryByFlags: '',
    SOBMandatoryByFlags: '',
    UnitsMandatoryByFlags: '',
  }
  const formats: IFormActualsTargetsSettings[] = [
    { ...emptyFormat, SubCategory: subCategoryA3 },
    { ...emptyFormat, SubCategory: subCategoryA4 },
  ]

  const crud = CrudStore.get(
    CrudStoreItemPartner360.JBPHPPartnerShareOfBusiness,
    category
  ) as Crud<IFormShareOfBusiness>

  //
  // Read SoB
  //

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: fYear,
      },
      {
        field: 'ProgramType',
        operator: Operator.EQUAL,
        value: programType,
      },
      {
        field: 'Category',
        operator: Operator.EQUAL,
        value: category,
      },
    ],
  })
  crud.setPaging({ page: 0, pageSize: 1000 })

  const result = await crud.fetch({ force: true })
  const originalSoBData = result.items || []

  const hideOverall = false
  let sobData: IFormShareOfBusinessItem[] =
    ShareOfBusinessHelper.normalizeDataBySubCategoriesTwoLevels(
      partnerId,
      programType,
      category,
      fYear,
      originalSoBData,
      hideOverall,
      formats
    )
  const isColapsed =
    !sobData.length ||
    !!sobData.filter((el) => el.SubCategory && el.SubCategory.endsWith('-overall')).length
  if (!hideOverall && !isColapsed) {
    sobData = ShareOfBusinessHelper.recalcOverallItem(sobData)
  }

  // Update SoB

  const a3HPBrand = topVendorBrandA3.find((it) => devicesInfo.a3[it.brand].name === 'HP')
  const a4HPItem = topVendorBrandA4.find((it) => devicesInfo.a4[it.brand].name === 'HP')
  if (a3HPBrand && a4HPItem) {
    const newA3Value = devicesInfo.a3[a3HPBrand.brand].spend * 100
    const newA4Value = devicesInfo.a4[a4HPItem.brand].spend * 100
    const quarters = [1, 2, 3, 4]

    let newData = sobData
    sobData.forEach((sob, idx) => {
      const isOverall = sob.SubCategory.includes('overall')
      if (sob.SubCategory === subCategoryA3) {
        quarters.forEach((q) => {
          const planField = `PlanQ${q}`
          newData = ShareOfBusinessHelper.changeShareOfBusinessPercent(
            newData,
            idx,
            planField,
            Number(newA3Value),
            isOverall
          )
        })
      }
      if (sob.SubCategory === subCategoryA4) {
        quarters.forEach((q) => {
          const planField = `PlanQ${q}`
          newData = ShareOfBusinessHelper.changeShareOfBusinessPercent(
            newData,
            idx,
            planField,
            Number(newA4Value),
            isOverall
          )
        })
      }
    })

    //
    // Save SoB
    //

    const valuesForUpdate = setDelete(newData, isColapsed)
    const onCreate = valuesForUpdate.filter(
      (el) =>
        el.EntryId === 0 &&
        (el.Changed ||
          (isColapsed ? el.SubCategory.endsWith('-overall') : el.SubCategory.endsWith('-other'))) &&
        !el.Delete
    )
    const onUpdate = valuesForUpdate.filter(
      (el) =>
        el.EntryId > 0 &&
        (el.Changed ||
          (isColapsed ? el.SubCategory.endsWith('-overall') : el.SubCategory.endsWith('-other'))) &&
        !el.Delete
    )
    const onDelete = valuesForUpdate.filter((el) => el.EntryId > 0 && el.Delete)

    let isSoBChanged = false
    if (onCreate.length) {
      await crud.create({ formId: '1221', code: 'hp-partner-share-of-business-1221' }, onCreate)
      isSoBChanged = true
    }
    if (onUpdate.length) {
      await crud.update({ formId: '1221', code: 'hp-partner-share-of-business-1221' }, onUpdate)
      isSoBChanged = true
    }
    if (onDelete.length) {
      await crud.deleteBatch(
        { formId: '1221', code: 'hp-partner-share-of-business-1221' },
        onDelete
      )
      isSoBChanged = true
    }

    // Trigger Completeness
    return isSoBChanged
  }

  throw new Error('Error on update SoB')
}
